module.exports = __webpack_public_path__ + "static/media/effet5.2fa5e392.ogg";